export default __webpack_public_path__ + "static/media/resume.7730f18d.pdf";